// extracted by mini-css-extract-plugin
export default {"formBody":"ImagePaintFields_formBody__bCYxG"};